import { ResponseUser } from "../types/account";
import { ApiPathComposer } from "./genPath";
import axiosClient from "./axiosClient";

class UserAPI {
  getUserInfo() {
    return axiosClient.get<ResponseUser>(ApiPathComposer.me).then((res) => res.data);
  }
}

const userAPI = new UserAPI();
export default userAPI;
